import React, { useState} from 'react';
import classes from './navbar.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch,faList } from '@fortawesome/free-solid-svg-icons';
const Navbar = props => {
    const[show,setShow]=useState(true);
    const controlNavbar=()=>{
        if(window.scrollY>100){
            setShow(false);
        }else{
            setShow(true);

        }
    }
   
    window.addEventListener('scroll',controlNavbar);
    
    return (
        <div className={classes['navbarsection']}>
            <div className={`navbar navbar-expand-lg navbar-light  bg-white ${show?`${classes.hidenavbar}`:{}}`} id={classes.whitenavbar}>
                <div className="container ">
                    <div className="navbar-brand"><img src="https://quomodosoft.com/html/dawat/demo/img/main_logo_black.png" alt="" /></div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span><FontAwesomeIcon icon={faList}/></span>
                    </button>
                    <div className="collapse navbar-collapse " id="navbarNav">
                        <ul className={`navbar-nav ms-auto ${classes.navlist2} text-white`}>
                            <li className="">
                                <a className="" aria-current="page" href="#">Home</a>
                            </li>
                            <li className="">
                                <a className="" href="#">Features</a>
                            </li>
                            <li className="">
                                <a className="" href="#">Pricing</a>
                            </li>
                            <li className="">
                                <a className="" href='#'>Disabled</a>
                            </li>
                            <li className="">
                                <a className="" href='#'><FontAwesomeIcon icon={faSearch} /></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className={`navbar navbar-expand-lg navbar-light ${!show?`${classes.hidenavbar}`:{}}`}  id={classes.lightnavbar}>
                <div className="container ">
                    <div className="navbar-brand"><img src="https://quomodosoft.com/html/dawat/demo/img/main_logo.png" alt="" /></div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className={classes.white}><FontAwesomeIcon icon={faList}/></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className={`navbar-nav ms-auto ${classes.navlist} text-white`}>
                            <li className="">
                                <a className="" aria-current="page" href="#">Home</a>
                            </li>
                            <li className="">
                                <a className="" href="#">Features</a>
                            </li>
                            <li className="">
                                <a className="" href="#">Pricing</a>
                            </li>
                            <li className="">
                                <a className="" href='#'>Disabled</a>
                            </li>
                            <li className="">
                                <a className="" href='#'><FontAwesomeIcon icon={faSearch} /></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Navbar;